const texts = {
    "ERROR.DEFAULT": {
        EN: "Something went wrong",
        DA: "Noget gik galt",
        DE: "Etwas ist schiefgelaufen",
        NL: "Er is iets misgegaan",
        FR: "Quelque chose s'est mal passé",
        IT: "Qualcosa è andato storto",
        ES: "Algo salió mal",
        PT: "Algo deu errado",
        FI: "Jokin meni pieleen",
        SV: "Något gick fel",
        NO: "Noe gikk galt",
    },
    "init.ERROR.DEFAULT": {
        EN: "Failed to retrieve shop information",
        DA: "Kunne ikke hente butiksoplysninger",
        DE: "Shopinformationen konnten nicht abgerufen werden",
        NL: "Kan winkelinformatie niet ophalen",
        FR: "Échec de la récupération des informations du magasin",
        IT: "Impossibile recuperare le informazioni del negozio",
        ES: "No se pudo obtener información de la tienda",
        PT: "Falha ao recuperar informações da loja",
        FI: "Kaupan tietojen hakeminen epäonnistui",
        SV: "Det gick inte att hämta butiksinformation",
        NO: "Kunne ikke hente butikkinformasjon",
    },
    "init.ERROR.INVALID_BRAND": {
        EN: "Brand not found. The URL might be incorrect",
        DA: "Mærke ikke fundet. URL'en kan være forkert",
        DE: "Marke nicht gefunden. Die URL könnte falsch sein",
        NL: "Merk niet gevonden. De URL kan onjuist zijn",
        FR: "Marque introuvable. L'URL peut être incorrecte",
        IT: "Marchio non trovato. L'URL potrebbe essere errato",
        ES: "Marca no encontrada. La URL podría ser incorrecta",
        PT: "Marca não encontrada. A URL pode estar incorreta",
        FI: "Brändiä ei löydetty. URL saattaa olla virheellinen",
        SV: "Varumärket hittades inte. Webbadressen kan vara felaktig",
        NO: "Merke ikke funnet. Nettadressen kan være feil",
    },
    "init.ERROR.INVALID_MERCHANT": {
        EN: "Merchant not found. The URL might be incorrect",
        DA: "Forhandler ikke fundet. URL'en kan være forkert",
        DE: "Händler nicht gefunden. Die URL könnte falsch sein",
        NL: "Handelaar niet gevonden. De URL kan onjuist zijn",
        FR: "Marchand introuvable. L'URL peut être incorrecte",
        IT: "Commerciante non trovato. L'URL potrebbe essere errato",
        ES: "Comerciante no encontrado. La URL podría ser incorrecta",
        PT: "Comerciante não encontrado. A URL pode estar incorreta",
        FI: "Kauppaa ei löydetty. URL saattaa olla virheellinen",
        SV: "Handlare hittades inte. Webbadressen kan vara felaktig",
        NO: "Selger ikke funnet. Nettadressen kan være feil",
    },
    "init.ERROR.INVALID_SALES_PLATFORM": {
        EN: "Sales Platform not found. The URL might be incorrect",
        DA: "Salgsplatform ikke fundet. URL'en kan være forkert",
        DE: "Verkaufsplattform nicht gefunden. Die URL könnte falsch sein",
        NL: "Verkoopplatform niet gevonden. De URL kan onjuist zijn",
        FR: "Plateforme de vente introuvable. L'URL peut être incorrecte",
        IT: "Piattaforma di vendita non trovata. L'URL potrebbe essere errato",
        ES: "Plataforma de ventas no encontrada. La URL podría ser incorrecta",
        PT: "Plataforma de vendas não encontrada. A URL pode estar incorreta",
        FI: "Myyntialustaa ei löydetty. URL saattaa olla virheellinen",
        SV: "Försäljningsplattformen hittades inte. Webbadressen kan vara felaktig",
        NO: "Finner ikke salgsplattform. Nettadressen kan være feil",
    },
    "login.ERROR.DEFAULT": {
        EN: "An unexpected error occurred. Please try again later.",
        DA: "Der opstod en uventet fejl. Prøv igen senere.",
        DE: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
        NL: "Er is een onverwachte fout opgetreden. Probeer het later opnieuw.",
        FR: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
        IT: "Si è verificato un errore imprevisto. Riprova più tardi.",
        ES: "Ocurrió un error inesperado. Por favor, inténtalo de nuevo más tarde.",
        PT: "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.",
        FI: "Odottamaton virhe tapahtui. Yritä myöhemmin uudelleen.",
        SV: "Något gick fel. Vänligen försök senare.",
        NO: "En uventet feil oppstod. Prøv igjen senere.",
    },
    "login.ERROR.INVALID_ORDER_STATE": {
        EN: "We are having some trouble with your order. Please contact us at ${supportEmail} and we will help you with your return.",
        DA: "Vi har nogle problemer med din ordre. Kontakt os venligst på ${supportEmail}, så hjælper vi dig med din retur.",
        DE: "Wir haben Probleme mit Ihrer Bestellung. Bitte kontaktieren Sie uns unter ${supportEmail} und wir helfen Ihnen bei Ihrer Rücksendung.",
        NL: "We hebben wat problemen met je bestelling. Neem contact met ons op via ${supportEmail} en we helpen je met je retour.",
        FR: "Nous rencontrons des problèmes avec votre commande. Veuillez nous contacter à ${supportEmail} et nous vous aiderons avec votre retour.",
        IT: "Stiamo avendo problemi con il tuo ordine. Contattaci a ${supportEmail} e ti aiuteremo con il tuo reso.",
        ES: "Tenemos problemas con tu pedido. Por favor contáctanos en ${supportEmail} y te ayudaremos con tu devolución.",
        PT: "Estamos com problemas com seu pedido. Entre em contato conosco em ${supportEmail} e ajudaremos com sua devolução.",
        FI: "Meillä on ongelmia tilauksesi kanssa. Ota yhteyttä osoitteeseen ${supportEmail} niin autamme palautuksessasi.",
        SV: "Vi har problem med din order. Kontakta oss på ${supportEmail} så hjälper vi dig med din retur.",
        NO: "Vi har problemer med bestillingen din. Kontakt oss på ${supportEmail}, så hjelper vi deg med returen.",
    },
    "login.ERROR.NO_RETURNABLE_ITEMS": {
        EN: "Order can't be returned",
        DA: "Ordre kan ikke returneres",
        DE: "Bestellung kann nicht zurückgegeben werden",
        NL: "Bestelling kan niet worden geretourneerd",
        FR: "La commande ne peut pas être retournée",
        IT: "L'ordine non può essere restituito",
        ES: "El pedido no puede ser devuelto",
        PT: "O pedido não pode ser devolvido",
        FI: "Tilausta ei voida palauttaa",
        SV: "Ordern kan inte returneras",
        NO: "Bestillingen kan ikke returneres",
    },
    "login.ERROR.INVALID_USER_CREDENTIALS": {
        EN: "Invalid email or order number. Please try again.",
        DA: "Ugyldig e-mail eller ordrenummer. Prøv igen.",
        DE: "Ungültige E-Mail oder Bestellnummer. Bitte versuchen Sie es erneut.",
        NL: "Ongeldig e-mailadres of bestelnummer. Probeer het opnieuw.",
        FR: "E-mail ou numéro de commande invalide. Veuillez réessayer.",
        IT: "Email o numero d'ordine non validi. Riprova.",
        ES: "Correo electrónico o número de pedido inválido. Por favor, inténtalo de nuevo.",
        PT: "E-mail ou número de pedido inválido. Por favor, tente novamente.",
        FI: "Virheellinen sähköposti tai tilausnumero. Yritä uudelleen.",
        SV: "E-postadress eller ordernummer stämmer inte. Försök igen.",
        NO: "Ugyldig e-post eller ordrenummer. Vær så snill, prøv på nytt.",
    },
    "login.ERROR.WITHDRAWAL_NOT_ENABLED": {
        EN: "Withdrawal from purchase is not available for this store. Please contact customer support.",
        SV: "Ångerrätt via den här tjänsten är inte tillgänglig för den här butiken. Kontakta kundtjänst.",
        NO: "Angrerett via denne tjenesten er ikke tilgjengelig for denne butikken. Kontakt kundeservice.",
        DA: "Fortrydelsesret via denne tjeneste er ikke tilgængelig for denne butik. Kontakt kundeservice.",
        DE: "Der Widerruf ist für diesen Shop hier nicht verfügbar. Bitte wenden Sie sich an den Kundenservice.",
        NL: "Herroeping van de aankoop is niet beschikbaar voor deze winkel. Neem contact op met de klantenservice.",
        FR: "La rétractation n'est pas disponible pour cette boutique. Veuillez contacter le service client.",
        IT: "Il recesso dall'acquisto non è disponibile per questo negozio. Contatta il servizio clienti.",
        ES: "El desistimiento de la compra no está disponible para esta tienda. Por favor, contacta con atención al cliente.",
        PT: "A desistência da compra não está disponível para esta loja. Entre em contato com o atendimento ao cliente.",
        FI: "Peruutusoikeutta ei voi käyttää tämän palvelun kautta tässä kaupassa. Ota yhteyttä asiakaspalveluun.",
    },
    "login.ERROR.LAST_RETURN_DATE_HAS_PASSED": {
        EN: "The last return date has passed. Please contact ${supportEmail} if you have a complaint request.",
        DA: "Den sidste returdato er passeret. Kontakt ${supportEmail} hvis du har en klage.",
        DE: "Das letzte Rückgabedatum ist abgelaufen. Bitte kontaktieren Sie ${supportEmail}, wenn Sie eine Beschwerde haben.",
        NL: "De laatste retourdatum is verstreken. Neem contact op met ${supportEmail} als je een klacht hebt.",
        FR: "La dernière date de retour est passée. Veuillez contacter ${supportEmail} si vous avez une réclamation.",
        IT: "L'ultima data di reso è passata. Contatta ${supportEmail} se hai un reclamo.",
        ES: "La fecha límite de devolución ha pasado. Por favor contacta ${supportEmail} si tienes una reclamación.",
        PT: "A última data de devolução passou. Entre em contato com ${supportEmail} se tiver uma reclamação.",
        FI: "Viimeinen palautuspäivä on mennyt. Ota yhteyttä ${supportEmail} jos sinulla on valituspyyntö.",
        SV: "Sista dagen för att returnera din order har passerat. Vänligen kontakta ${supportEmail} om du vill göra en reklamation.",
        NO: "Siste returdato har passert. Ta kontakt med ${supportEmail} hvis du har en klageforespørsel.",
    },
    "login.ERROR.ORDER_ALREADY_SUBMITTED": {
        EN: "A return has already been submitted for this order.",
        DA: "Der er allerede indsendt en retur for denne ordre.",
        DE: "Für diese Bestellung wurde bereits eine Rücksendung eingereicht.",
        NL: "Er is al een retour ingediend voor deze bestelling.",
        FR: "Un retour a déjà été soumis pour cette commande.",
        IT: "È già stato inviato un reso per questo ordine.",
        ES: "Ya se ha enviado una devolución para este pedido.",
        PT: "Já foi enviada uma devolução para este pedido.",
        FI: "Tälle tilaukselle on jo lähetetty palautus.",
        SV: "En retur har redan registrerats med detta ordernummer.",
        NO: "Det er allerede sendt inn en retur for denne bestillingen.",
    },
    "login.ERROR.SESSION_EXPIRED": {
        EN: "Your session expired. Please reload the page.",
        DA: "Din session er udløbet. Genindlæs venligst siden.",
        DE: "Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite neu.",
        NL: "Je sessie is verlopen. Laad de pagina opnieuw.",
        FR: "Votre session a expiré. Veuillez recharger la page.",
        IT: "La tua sessione è scaduta. Ricarica la pagina.",
        ES: "Tu sesión ha expirado. Por favor recarga la página.",
        PT: "Sua sessão expirou. Por favor recarregue a página.",
        FI: "Istuntosi on vanhentunut. Lataa sivu uudelleen.",
        SV: "Din session har gått ut. Ladda om sidan.",
        NO: "Økten din har utløpt. Last inn siden på nytt.",
    },
    "login.ERROR.NO_PRICE_LIST_MATCHING_ORDER": {
        EN: "Returns are not available on this order. Please contact the store for more information - Region/Product preconditions do not match any price list",
        DA: "Returner er ikke tilgængelige for denne ordre. Kontakt butikken for mere information - Region/Produkt betingelser matcher ikke nogen prisliste",
        DE: "Rücksendungen sind für diese Bestellung nicht verfügbar. Bitte kontaktieren Sie das Geschäft für weitere Informationen - Region/Produkt Voraussetzungen stimmen mit keiner Preisliste überein",
        NL: "Retouren zijn niet beschikbaar voor deze bestelling. Neem contact op met de winkel voor meer informatie - Regio/Product voorwaarden komen niet overeen met een prijslijst",
        FR: "Les retours ne sont pas disponibles pour cette commande. Veuillez contacter le magasin pour plus d'informations - Les conditions de région/produit ne correspondent à aucune liste de prix",
        IT: "I resi non sono disponibili per questo ordine. Contatta il negozio per ulteriori informazioni - I prerequisiti Regione/Prodotto non corrispondono a nessun listino prezzi",
        ES: "Las devoluciones no están disponibles para este pedido. Por favor contacta la tienda para más información - Las condiciones de Región/Producto no coinciden con ninguna lista de precios",
        PT: "Devoluções não estão disponíveis para este pedido. Entre em contato com a loja para mais informações - As pré-condições de Região/Produto não correspondem a nenhuma lista de preços",
        FI: "Palautuksia ei ole saatavilla tälle tilaukselle. Ota yhteyttä kauppaan saadaksesi lisätietoja - Alue/Tuote ehdot eivät täsmää mihinkään hinnastoon",
        SV: "Returer är inte tillgängliga för den här ordern. Kontakta butiken för mer information – villkor för region/produkt matchar ingen prislista",
        NO: "Returer er ikke tilgjengelige for denne bestillingen. Kontakt butikken for mer informasjon – forutsetninger for region/produkt samsvarer ikke med noen prisliste",
    },
    "login.ERROR.SHIPMENT_SOLUTION_MISSING": {
        EN: "Returns are not available on this order. Please contact the store for more information - Shipment option preconditions do not match",
        DA: "Returner er ikke tilgængelige for denne ordre. Kontakt butikken for mere information - Forsendelsesmuligheder matcher ikke",
        DE: "Rücksendungen sind für diese Bestellung nicht verfügbar. Bitte kontaktieren Sie das Geschäft für weitere Informationen - Versandoptionen stimmen nicht überein",
        NL: "Retouren zijn niet beschikbaar voor deze bestelling. Neem contact op met de winkel voor meer informatie - Verzendopties komen niet overeen",
        FR: "Les retours ne sont pas disponibles pour cette commande. Veuillez contacter le magasin pour plus d'informations - Les options d'expédition ne correspondent pas",
        IT: "I resi non sono disponibili per questo ordine. Contatta il negozio per ulteriori informazioni - Le opzioni di spedizione non corrispondono",
        ES: "Las devoluciones no están disponibles para este pedido. Por favor contacta la tienda para más información - Las opciones de envío no coinciden",
        PT: "Devoluções não estão disponíveis para este pedido. Entre em contato com a loja para mais informações - As opções de envio não correspondem",
        FI: "Palautuksia ei ole saatavilla tälle tilaukselle. Ota yhteyttä kauppaan saadaksesi lisätietoja - Toimitusvaihtoehdon ehdot eivät täsmää",
        SV: "Returer är inte tillgängliga för den här ordern. Kontakta butiken för mer information – försändelsesalternativens villkor matchar inte",
        NO: "Returer er ikke tilgjengelige for denne bestillingen. Kontakt butikken for mer informasjon – forutsetninger for fraktalternativ samsvarer ikke",
    },
    "return-products.ERROR.DEFAULT": {
        EN: "Failed to submit product selection",
        DA: "Kunne ikke indsende produktvalg",
        DE: "Fehler beim Absenden der Produktauswahl",
        NL: "Kan productselectie niet verzenden",
        FR: "Échec de la soumission de la sélection de produits",
        IT: "Impossibile inviare la selezione del prodotto",
        ES: "Error al enviar la selección de productos",
        PT: "Falha ao enviar seleção de produtos",
        FI: "Tuotevalinnan lähettäminen epäonnistui",
        SV: "Det gick inte att skicka produktvalet",
        NO: "Kunne ikke sende inn produktvalg",
    },
    "return-products.ERROR.INVALID_PRODUCTS": {
        EN: "Invalid product selection. Verify your selected products and try again",
        DA: "Ugyldigt produktvalg. Verificer dine valgte produkter og prøv igen",
        DE: "Ungültige Produktauswahl. Überprüfen Sie Ihre ausgewählten Produkte und versuchen Sie es erneut",
        NL: "Ongeldige productselectie. Verifieer je geselecteerde producten en probeer opnieuw",
        FR: "Sélection de produits invalide. Vérifiez vos produits sélectionnés et réessayez",
        IT: "Selezione prodotto non valida. Verifica i tuoi prodotti selezionati e riprova",
        ES: "Selección de productos inválida. Verifica tus productos seleccionados e inténtalo de nuevo",
        PT: "Seleção de produtos inválida. Verifique seus produtos selecionados e tente novamente",
        FI: "Virheellinen tuotevalinta. Tarkista valitut tuotteet ja yritä uudelleen",
        SV: "Ogiltigt produktval. Kontrollera dina valda produkter och försök igen",
        NO: "Ugyldig produktvalg. Bekreft de valgte produktene og prøv igjen",
    },
    "return-products.ERROR.SESSION_EXPIRED": {
        EN: "User session expired. Please try again",
        DA: "Brugersession udløbet. Prøv igen",
        DE: "Benutzersitzung abgelaufen. Bitte versuchen Sie es erneut",
        NL: "Gebruikerssessie verlopen. Probeer opnieuw",
        FR: "Session utilisateur expirée. Veuillez réessayer",
        IT: "Sessione utente scaduta. Riprova",
        ES: "Sesión de usuario expirada. Por favor, inténtalo de nuevo",
        PT: "Sessão do usuário expirou. Por favor, tente novamente",
        FI: "Käyttäjäistunto vanhentunut. Yritä uudelleen",
        SV: "Användarsessionen har gått ut. Försök igen",
        NO: "Brukerøkten er utløpt. Vær så snill, prøv på nytt",
    },
    "product-exchange.ERROR.DEFAULT": {
        EN: "Failed to fetch product exchange items",
        DA: "Kunne ikke hente produktbyttevarer",
        DE: "Fehler beim Abrufen von Produkttauschartikeln",
        NL: "Kan ruilproducten niet ophalen",
        FR: "Échec de la récupération des articles d'échange de produits",
        IT: "Impossibile recuperare gli articoli di scambio prodotto",
        ES: "Error al obtener artículos de intercambio de productos",
        PT: "Falha ao buscar itens de troca de produtos",
        FI: "Tuotevaihtoehtoja ei voitu hakea",
        SV: "Det gick inte att hämta produkter för byte",
        NO: "Kunne ikke hente varebyttevarer",
    },
};
export default texts;
